import React from 'react';
import { Modal, Button } from 'flowbite-react';

export default function ConfirmModal({ open, onClose, title = 'Подтверждение', message = 'Подтвердите действие', confirmText = 'Подтвердить', cancelText = 'Отмена', onConfirm }) {
  return (
    <Modal show={open} size="md" onClose={onClose} popup>
      <Modal.Header />
      <Modal.Body>
        <div className="text-center">
          <h3 className="mb-5 text-lg font-normal text-gray-500">{title}</h3>
          <p className="mb-5 text-sm text-gray-500">{message}</p>
          <div className="flex justify-center gap-4">
            <Button color="failure" onClick={onConfirm}>{confirmText}</Button>
            <Button color="gray" onClick={onClose}>{cancelText}</Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}